/* eslint-disable class-methods-use-this */
/* eslint-disable prettier/prettier */
import apiClient from './apiClient';

export class CityRepository {
    async fetchCityPaths() {
        try {
            const response = await apiClient.get('/api/line/getcitypathname');
            if (response.data.success) {
                return response.data.data;
            }
            throw new Error(response.data.message || '獲取城市路徑失敗');
        } catch (error) {
            console.error('Error fetching city paths:', error);
            throw new Error('無法連接到城市路徑服務');
        }
    }

    async fetchCitySettings() {
        try {
            const response = await apiClient.get('/api/line/getcitysitting');
            if (response.data.success) {
                return response.data.data;
            }
            throw new Error(response.data.message || '獲取城市設置失敗');
        } catch (error) {
            console.error('Error fetching city settings:', error);
            throw new Error('無法連接到城市設置服務');
        }
    }
}